import { Point, SparseArray } from "../Model";


export function makeSparseArray(width: number, height: number):SparseArray {
  return {
    width,
    height,
    bits: new Array<boolean>(width * height).fill(false)
  };
}

export function setBit(sparse: SparseArray, x: number, y: number): SparseArray {
  sparse.bits[(y * sparse.width) + x] = true;
  return sparse;
}

export function setBitAtPoint(sparse: SparseArray, p: Point): SparseArray {
  sparse.bits[(p[1] * sparse.width) + p[0]] = true;
  return sparse;
}

export function contains(sparse: SparseArray, p: Point): boolean {
  return sparse.bits[(p[1] * sparse.width) + p[0]]
}

export function sparseArrayToPointsArray(sparse: SparseArray): Array<Point> {
  const points: Array<Point> = [];
  if (sparse) {
    withEachSetBit(sparse, (p:Point) => points.push(p));
  }

  return points;
}

export type PointList = Array<number>;

export function toOptimalPolyArray(sparse: SparseArray): Array<PointList> {
  const { height, width, bits} = sparse;
  const segments: Array<PointList> = []
  for (let y = height -1; y >= 0; y--) {
    let runStart = -1;
    let runEnd = -1;
    for (let x = width -1; x >= 0; x--) {
      if (bits[(y * width) + x]) {
        if (runStart === -1) {
          runStart = x;
          runEnd = x;
          // console.log(`Run start at ${x}, ${y}`)
        } else if (x === (runEnd - 1)) {
          // extend the run
          runEnd = x;
        } 
      } else {
        if (runStart !== -1) {
          // console.log(`Run done at ${JSON.stringify([runStart,y,runEnd,y], null, 2)}`)
          // That is it for the run
          const pointList = [runStart,y,runEnd,y]
          segments.push(pointList);
          runStart = -1;
        } 
      }
    }
  }

  if (segments.length < 2) {
    return segments;
  }

  // Phase 2, look for "stacked" segments
  const optimisedForStacks: Array<PointList> = []
  let currentStack:PointList = [];
  let westmost, eastmost, row = 0, startRow = 0;

  for (let i = 0; i < segments.length; i++) {
    const currentSegment=segments[i];
    // console.log(`considering ${currentSegment}`)
    if (currentStack.length === 0) {
      currentStack = currentSegment;
      eastmost = currentSegment[0];
      westmost = currentSegment[2];
      startRow = currentSegment[1];
      row = currentSegment[1];
      // console.log(`initing ${currentSegment}, e: ${eastmost}, w: ${westmost}, row; ${row}`)

    } else {
      if (currentSegment[0] === eastmost && currentSegment[2] === westmost && currentSegment[1] === (row -1)) {
        // the segment and the current stack are have the same start and end points and are on consecutive rows
        // Therefore the lines should be combined to make a box
        // The currentStack should always be [e,s,w,s,w,n,e,n]
        const currentRow = currentSegment[1];
        // console.log(`stack continues onto ${currentRow}`);
        row = currentRow;
        currentStack = [eastmost, startRow, westmost, startRow, westmost, currentRow, eastmost, currentRow];
      } else {
        // stack has ended; push it
        // console.log(`stack ended, pushing onto ${currentStack}`);
        optimisedForStacks.push(currentStack);
        currentStack = currentSegment;
        eastmost = currentSegment[0]
        westmost = currentSegment[2]
        row = currentSegment[1]
        startRow = row;
        // console.log(`currentStack now ${currentStack}, startRow is ${startRow}; w: ${westmost}, e: ${eastmost}, row: ${row}`);

      }
    }
  }

  // Push any final stack:
  optimisedForStacks.push(currentStack);

  return optimisedForStacks;
  // return segments;
}

export function withEachSetBit(sparse: SparseArray, fn: (p: Point) => void): void {
  const { height, width, bits} = sparse;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      if (bits[(y * width) + x]) {
        fn([x,y]);
      }
    }
  }
}


export function pointsArrayToSparseArray(points: Array<Point>, width: number, height: number): SparseArray {
  const sparse = makeSparseArray(width, height);
  points.forEach((p) => setBit(sparse, p[0], p[1]));
  return sparse;
}